<template>
  <div class="filters">
    <div class="filter-item">
      <label>State:</label>
      <select v-model="selectedState" @change="emitState">
        <option value="">All States</option>
      <option v-for="state in stateOptions" :key="state.key" :value="state.key">
        {{ state.label }}
      </option>
      </select>
    </div>

    <div class="filter-item">
      <label>City:</label>
      <select v-model="selectedCity" @change="emitCity">
        <option value="">All Cities</option>
        <option v-for="city in cityOptions" :key="city" :value="city">
          {{ city }}
        </option>
      </select>
    </div>
  </div>
</template>


<script>
import { mapGetters,mapActions  } from "vuex";

export default {
  name: "CityStateFilter",
  data() {
    return {
      selectedState: "",
      selectedCity: "",
      cityOptions: [],
      stateOptions: [],
      cityStateMap: {} // holds raw JSON map
    };
  },
  computed: {
    ...mapGetters(["getCityStateFilters","getCity", "getState"]),
  },
  watch: {
    selectedState() {
      const stateData = this.cityStateMap[this.selectedState];
      this.cityOptions = stateData ? stateData.cities : [];
      this.emitFilter();
    },
    selectedCity(newVal) {
      this.emitFilter();
    },
    getState(newVal) {
      this.selectedState = newVal;
    },
    getCity(newVal) {
      this.selectedCity = newVal;
    }
  },
  mounted() {
    const filters = this.getCityStateFilters;
    this.selectedState = this.getState || "";
    this.selectedCity = this.getCity || "";
    if (filters) {
      this.cityStateMap = filters;

      this.stateOptions = Object.entries(filters).map(([key, val]) => ({
        key,
        label: val.label
      })).sort((a, b) => a.label.localeCompare(b.label));

      // Restore from Vuex
      const savedState = this.getState || "";
      const savedCity = this.getCity || "";

      if (savedState) {
        this.selectedState = savedState;

        if (filters[savedState]) {
          this.cityOptions = filters[savedState].cities;

          if (this.cityOptions.includes(savedCity)) {
            this.selectedCity = savedCity;
          }
        }
      }

      // If values are already present, emit once
      if (this.selectedState || this.selectedCity) {
        this.emitFilter();
      }
    }
  },
  methods: {
    ...mapActions([
      "sendSearchReqAnalyticsAll",
      "sendSearchReqAnalytics"
    ]),
    emitState(){
      this.selectedCity = "";
      this.$store.commit('SET_SELECTED_CITY',"");
      this.$store.commit('SET_SELECTED_STATE', this.selectedState);
      const stateData = this.cityStateMap[this.selectedState];
      this.cityOptions = stateData ? stateData.cities : [];
    },
    emitCity() {
      this.$store.commit('SET_SELECTED_CITY', this.selectedCity);
    },
    emitFilter() {
      this.sendSearchReqAnalyticsAll();
      this.sendSearchReqAnalytics();
    },
  },
};
</script>

<style scoped>
.filters {
  display: flex;
  gap: 1rem; /* 16px */
  justify-content: flex-end;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

label {
  font-family: TTNormsBold, sans-serif;
  color: #1546ad;
  margin: 0;
}

select {
  padding: 5px 10px;
  font-size: 16px;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsLight, sans-serif;
  background: white;
  border-radius: 5px;
  border: 1px solid #ccc;
  min-width: 150px;
}
</style>
